import React from 'react';
import { FaRegBuilding, FaRegFileAlt, FaPhoneAlt } from 'react-icons/fa';
import { BiTransfer } from 'react-icons/bi';
import { MdOutlineManageAccounts } from 'react-icons/md';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { TbFileInvoice } from 'react-icons/tb';
import { AiOutlineApi } from 'react-icons/ai';
import { BsStars } from 'react-icons/bs';
import './styles.css';

const PlanFeatures = () => {
  const features = [
    {
      icon: <FaRegBuilding />,
      title: 'Publicação flexível',
      description: 'Escolha entre planos mensais ou anuais.'
    },
    {
      icon: <FaRegFileAlt />,
      title: 'Descrições interessantes',
      description: 'Apresente ao seu imóvel imagens e informações completas no nosso site internacional.'
    },
    {
      icon: <FaPhoneAlt />,
      title: 'Liberdade',
      description: 'Contacto direto com o cliente.'
    },
    {
      icon: <BiTransfer />,
      title: 'Sem comissões',
      description: 'Sem taxa de serviço do subtotal da reserva.'
    },
    {
      icon: <MdOutlineManageAccounts />,
      title: 'Gerenciamento Simples',
      description: 'Acompanhe o seu anúncio, e-mails e análises por meio de uma interface amigável.'
    },
    {
      icon: <RiMoneyDollarCircleLine />,
      title: 'Preços competitivos',
      description: 'Oferecemos tarifas atrativas em comparação com outros sites de propriedades internacionais.'
    },
    {
      icon: <TbFileInvoice />,
      title: 'IVA adaptado',
      description: 'O IVA é ajustado dependendo do país ao comprar o plano'
    },
    {
      icon: <AiOutlineApi />,
      title: 'Integração simples',
      description: 'Ligue o CRM da sua agência à nossa API para uma colocação rápida do anúncio.'
    },
    {
      icon: <BsStars />,
      title: 'Aspetos-Chave para Sobressair',
      description: 'Amplie consideravelmente a exposição da sua empresa e conquiste um aumento significativo no número de contatos recebidos. Publicação durante 30 dias.'
    }
  ];

  return (
    <section className="plan-features">
      <div className="features-header">
        <h2>Joviplanet</h2>
        <p>Muito mais que uma rede, um universo de possibilidades!</p>
      </div>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <div className="feature-icon">
              {feature.icon}
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlanFeatures; 